import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AdminComponent } from './admin/admin.component';
import { RegistrationSuccessComponent } from './registration-success/registration-success.component';
import { RegistrationUnsuccessComponent } from './registration-unsuccess/registration-unsuccess.component';
import { VerifyTeacherEmailComponent } from './verify-teacher-email/verify-teacher-email.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'admin', component: AdminComponent },
  { path: 'registration/success', component: RegistrationSuccessComponent },
  { path: 'registration/unsuccess', component: RegistrationUnsuccessComponent },
  { path: 'verify-teacher-email/:uuid/:uuid_hash/:email_hash', component: VerifyTeacherEmailComponent },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
